// extracted by mini-css-extract-plugin
export default {"modalCloseButton":"Modal_modalCloseButton__ehs9c","modalContent":"Modal_modalContent__94nCg"};